import { render, staticRenderFns } from "./BroadcastHistoryView.vue?vue&type=template&id=0b8f655d&"
import script from "./BroadcastHistoryView.vue?vue&type=script&lang=ts&"
export * from "./BroadcastHistoryView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports